import IconText from '@/business-components/IconText';
import { openUrlV2 } from '@/common/bridge/openUrl';
import { scaleW } from '@/common/style';
import { KImage, KImageBackground } from '@/component/RtlLayout';
import { KTouchableWithoutFeedback } from '@/component/RtlLayout/Touchable';
import { $k18n } from '@/common/i18n';
import React from 'react';
import { View, Text } from 'react-native';

export function HorizontalProductCard(props: { product: any; rank: number; onClick?: () => void }) {
    const { rank, product, onClick = () => undefined } = props;
    const rankImageMap = {
        1: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rank_1.png',
        2: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rank_2.png',
        3: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rank_3.png',
        4: 'https://cdn-static.ap4r.com/kos/s101/nlav11312/shop-krn/rank_4.png',
    };
    return (
        <KTouchableWithoutFeedback
            onPress={() => {
                onClick?.();
            }}>
            <View style={{"padding":"1.9323671497584543rem","flexDirection":"row","alignItems":"center","backgroundColor":"white","borderRadius":"1.9323671497584543rem"}}>
                {/* 商品图片 */}
                <View style={{"borderRadius":"0.9661835748792271rem","overflow":"hidden","marginRight":"1.9323671497584543rem"}}>
                    <View
                        style={{"position":"absolute","width":"5.314009661835749rem","height":"5.314009661835749rem","left":"1.2077294685990339rem","top":"0rem","zIndex":10}}>
                        <KImageBackground
                            source={{ uri: rankImageMap[rank] || rankImageMap[4] }}
                            style={{"width":"4.1062801932367154rem","height":"4.1062801932367154rem","alignItems":"center","justifyContent":"center"}}>
                            {rank > 3 ? <Text style={{"fontSize":"2.4154589371980677rem","fontWeight":"900","marginBottom":"0.7246376811594204rem"}}>{rank}</Text> : null}
                        </KImageBackground>
                    </View>
                    <KImage
                        source={{
                            uri: product.templateImageUrls?.[0] || product.imageUrl,
                        }}
                        style={{"width":"11.594202898550726rem","height":"11.594202898550726rem"}}
                    />
                </View>
                {/* 商品信息： 标题 + 价格 + 销量 */}
                <View style={{"flexShrink":1,"flexGrow":1,"justifyContent":"space-between"}}>
                    <IconText
                        title={product.title}
                        tagList={product.tag}
                        titleLine={1}
                        customerTagStyle={{ top: 1 }}
                        customerContainerStyle={{ marginTop: 0 }}
                    />
                    <View style={{"flexDirection":"row","alignItems":"flex-end"}}>
                        <Text
                            style={{"color":"rgba(255, 73, 6, 1)","lineHeight":"4.5893719806763285rem","fontSize":"3.8647342995169085rem","marginRight":"0.9661835748792271rem","fontWeight":"700"}}>
                            {product.displaySalePrice}
                        </Text>
                        <Text
                            style={{"color":"rgba(153, 153, 153, 1)","lineHeight":"3.8647342995169085rem","fontSize":"2.8985507246376816rem","fontWeight":"400","marginBottom":"0.48309178743961356rem"}}>
                            {$k18n({ id: 'k_269959', text: '已售{soldNo}', params: { soldNo: product.displaySaleCount } })}
                        </Text>
                    </View>
                </View>
            </View>
        </KTouchableWithoutFeedback>
    );
}
